<!-- One row: filters, a bounded search, and Sort by at the right edge; it wraps only when narrow. -->
<div class="dl-toolbar">
  <ng-content select="[list-filters]"></ng-content>
  <input *ngIf="searchable" type="search" class="br-form-control br-form-control--sm dl-search"
         [formControl]="searchCtrl" [placeholder]="searchPlaceholder" aria-label="Search items" />
  <ng-container *ngIf="sortOptions.length">
    <button type="button" class="br-table-filter-trigger dl-sort" aria-label="Sort by"
            [brMenuTriggerFor]="sortMenu">
      <span>Sort by: {{ selectedSort?.label || 'Default' }}</span>
      <br-icon>keyboard_arrow_down</br-icon>
    </button>
    <ng-template #sortMenu>
      <br-menu aria-label="Sort by">
        <button brMenuItem label="Default" [current]="!selectedSort" (triggered)="setSort(null)"></button>
        <button brMenuItem *ngFor="let option of sortOptions" [label]="option.label"
                [current]="selectedSort === option" (triggered)="setSort(option)"></button>
      </br-menu>
    </ng-template>
  </ng-container>
</div>
<div *ngIf="selectable" class="dl-selection">
  <label class="dl-select">
    <input type="checkbox" class="br-form-check-input" aria-label="Select all loaded items"
           [checked]="allLoadedSelected" [indeterminate]="selection.hasValue() && !allLoadedSelected"
           [disabled]="!items.length" (change)="toggleAllLoaded()" />
    <span>{{ selectionBinding?.selectedCount != null ? 'Select loaded items' : 'All loaded (' + items.length + ')' }}</span>
  </label>
  <span *ngIf="selection.count > 0" class="br-text-muted" role="status">{{ selection.count }} selected</span>
  <ng-container *ngIf="selection.hasValue()">
    <ng-content select="[list-selection-actions]"></ng-content>
  </ng-container>
</div>
<div class="dl-scroll" #scrollBox tabindex="0" aria-label="Results" [attr.aria-busy]="loading">
  <div role="list" class="dl-items" [class.dl-items--grid]="layout === 'grid'">
    <article *ngFor="let item of items; let index = index; trackBy: trackByFn" appDataListCard
             [class.dl-item--selected]="selectable && selection.isSelected(item)"
             [class.dl-item--revealed]="revealedItem === item"
             [detailTemplate]="detailDef?.template || null" [detailContext]="{ $implicit: item }"
             [expanded]="expandedItem === item" (expandedChange)="toggle(item)">
      <label *ngIf="selectable" data-list-selection class="dl-select">
        <input type="checkbox" class="br-form-check-input" [attr.aria-label]="'Select item ' + (index + 1)"
               [checked]="selection.isSelected(item)" (change)="selection.toggle(item)" />
      </label>
      <ng-container *ngIf="itemDef" [ngTemplateOutlet]="itemDef.template"
                    [ngTemplateOutletContext]="{ $implicit: item }"></ng-container>
    </article>
  </div>
  <app-data-list-load-more [hasMore]="hasMore" [loading]="loading" [error]="errorMessage"
                           [showLoading]="showLoading" [emptyTemplate]="emptyTemplate" [empty]="!items.length" [emptyText]="emptyText" [autoLoadMore]="autoLoadMore"
                           [progress]="items.length" (more)="loadMore()" (retry)="retry()"></app-data-list-load-more>
</div>
